export enum SnackbarColor {
    Success = 'success-lighten-1',
    Error = 'error',
    Info = 'info',
    Warning = 'warning',
}

export enum SnackbarIcon {
    Success = 'mdi-check-circle',
    Error = 'mdi-alert',
    Info = 'mdi-information',
    Warning = 'mdi-alert-circle',
}
